import React, { Component, useState, Fragment } from "react";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import { Accordion, Card } from "react-bootstrap";
import CheckBoxComponent from '../CheckBox';
import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";
import ProvincesComponent from "../../components/Provinces";
import SelectComponent from "../../components/Select";
import { SpaceBox } from "../../components/Space";
import { Step3Langague } from "../../data/locale";
import InputMask from "react-input-mask";
const imgScale = {
    width: "24px",
    height: "24px"
  };
const Icon = props => (
    <img className={props.className} src={props.src} {...imgScale} />
);

function CustomToggle({ init, children, eventKey, text }) {
    const decoratedOnClick = useAccordionToggle(eventKey);
    const [toggle, setToggle] = useState(true);
  
    const onToggle = e => {
      e.stopPropagation();
      setToggle(!toggle);
      decoratedOnClick();
    };

    return (
        <div className="d-flex align-item-center accordion-header" onClick={e => onToggle(e)}>
            <p className="header-accordion-text position-relative">
              ต้องการออกใบเสร็จในนาม
            </p>

            <Icon className="ml-auto" src={toggle ? SpanMoreTabTop : SpanMoreTabDown} />
        </div>
    );
}

export default class TaxReciept extends Component {
  _SpaceBox() {
    return <SpaceBox w={"14px"} />;
  }
  render() {
    const { onChangeModel, checked, reciever, step3, benefitTitles } = this.props;
    const { 
      recieverID, 
      reciever_sInit, 
      recieverCompany, 
      recieverCompanyNo,
      recieverCompanyPhone,
      recieverPhone,
      recieverEmail,
      sNo,
      sMoo,
      sSoi,
      sRoad,
      sProvince,
      sDistrict,
      sCity,
      sZipcode,
      onChangeModelProvinces
    } = step3;

    return(
      <>
        {checked &&
        <Accordion defaultActiveKey={"0"} className="accordion-wrapper">
          <Card className="accordion-item" key={"0"}>
            <CustomToggle text="รูปแบบรับกรมธรรม์" eventKey={"0"} />
              <Accordion.Collapse eventKey={"0"}>
                <Card.Body className="pt-1">
                  <div className="d-flex flex-column flex-wrap">
                    <div className={`d-inline radio-button select-horizontal w-100 h-100 ${reciever === "assured" ? "active" : ""}`}
                      onClick={() => {onChangeModel({ name: "taxReciept", value: "assured" })}}
                    >   
                      <div className="radio d-inline-block ml-0" />
                      <div className="d-inline-block" style={{marginLeft: "30px"}}>
                        ผู้เอาประกันภัย
                      </div>
                    </div>
                    <div className={`d-inline radio-button select-horizontal w-100 h-100 mt-2 ${reciever === "legal_person" ? "active" : ""}`}
                      onClick={() => {onChangeModel({ name: "taxReciept", value: "legal_person" })}}
                    >   
                      <div className="radio d-inline-block ml-0" />
                      <div className="d-inline-block" style={{marginLeft: "30px"}}>นิติบุคคล</div>
                    </div>
                    <div className="radio-button h-0"><div className="radio visibility-hidden"/></div>     
                    {/* ################ */}
                    {/* ##### FORM ##### */}
                    {/* ################ */}
                    {reciever === "legal_person" &&
                    <div className="form-wrapper px-0">
                      {/* ========== */}
                      <div className="form-group">
                        <label className="">เลขทะเบียนนิติบุคคล</label>
                        <InputMask
                          mask="9-9999-99999-99-9"
                          maskChar="_"
                          type="tel"
                          value={recieverID}
                          onChange={e =>
                            onChangeModel({ name: e.target.name, value: e.target.value })
                          }
                        >
                          {inputProps => (
                            <input
                              id={recieverID}
                              {...inputProps}
                              className="form-control"
                              placeholder="ตัวเลข 13 หลัก"
                              name="recieverID"
                            />
                          )}
                        </InputMask>
                      </div>
                      {/* ========== */}
                      <div className="form-group">
                        <label>คำนำหน้า</label>
                        <SelectComponent
                        placeholder="คำนำหน้า"
                        options={benefitTitles}
                        selected={reciever_sInit}
                        onChange={selected =>
                          onChangeModel({ name: "reciever_sInit", value: selected })
                        }
                        />
                      </div>
                      {/* ========== */}
                      <div className="form-group">
                        <label>ชื่อบริษัท</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อบริษัท"
                          name="recieverCompany"
                          value={recieverCompany}
                          onChange={e =>
                            onChangeModel({ name: e.target.name, value: e.target.value })
                          }
                          />
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="เลขที่สาขา"
                          name="recieverCompanyNo"
                          value={recieverCompanyNo}
                          onChange={e =>
                            onChangeModel({ name: e.target.name, value: e.target.value })
                          }
                        />
                      </div>
                      {/* ========== */}
                      <div className="form-group">
                        <label>เบอร์ติดต่อ <label className="ml-0 text-gray">(ไม่จำเป็น)</label></label>
                        <InputMask
                          mask="9999999999"
                          type="tel"
                          value={recieverCompanyPhone}
                          onChange={e =>
                            onChangeModel({ name: e.target.name, value: e.target.value })
                          }
                        >
                            {inputProps => (
                              <input 
                              {...inputProps}
                              className="form-control"
                              placeholder="เบอร์ที่ทำงาน"
                              name="recieverCompanyPhone"
                              />
                              )}
                        </InputMask>
                        <InputMask
                          mask="9999999999"
                          type="tel"
                          value={recieverPhone}
                          onChange={e =>
                            onChangeModel({ name: e.target.name, value: e.target.value })
                          }
                        >
                            {inputProps => (
                              <input
                              {...inputProps}
                              className="form-control mt-2"
                              placeholder="เบอร์มือถือ"
                              name="recieverPhone"
                              />
                              )}
                        </InputMask>
                      </div>
                      {/* ========== */}
                      <div className="form-group">
                        <label>อีเมล <label className="ml-0 text-gray">(ไม่จำเป็น)</label></label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="อีเมล"
                          name="recieverEmail"
                          value={recieverEmail}
                          onChange={e =>
                            onChangeModel({ name: e.target.name, value: e.target.value })
                          }
                        />
                      </div>
                      {/* ========== */} 
                      <div className="form-group">
                        <label>ที่อยู่</label>
                        <div className="d-flex flex-row">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="เลขที่"
                            name="sNo"
                            value={sNo}
                            onChange={e =>
                              onChangeModel({ name: e.target.name, value: e.target.value })
                            }
                            />
                          {this._SpaceBox()}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="หมู่"
                            name="sMoo"
                            value={sMoo}
                            onChange={e =>
                              onChangeModel({ name: e.target.name, value: e.target.value })
                            }
                            />
                        </div>
                      </div>
                      {/* ========== */}
                      <div className="form-group">
                        <div className="d-flex flex-row">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="ซอย"
                            name="sSoi"
                            value={sSoi}
                            onChange={e =>
                              onChangeModel({ name: e.target.name, value: e.target.value })
                            }
                            />
                          {this._SpaceBox()}
                          <input
                            type="text"
                            className="form-control"
                            placeholder="ถนน"
                            name="sRoad"
                            value={sRoad}
                            onChange={e =>
                              onChangeModel({ name: e.target.name, value: e.target.value })
                            }
                          />
                        </div>
                      </div>
                      {/* ========== */}
                      <ProvincesComponent
                        lang={"th"}
                        langague={Step3Langague}
                        provinces={{ sProvince , sDistrict , sCity , sZipcode }}
                        onChange={object => onChangeModelProvinces(object)}
                        />
                    </div>
                    }
                    {/* ################ */}
                    {/* ##### FORM ##### */}
                    {/* ################ */}
                    <div className="mt-3 help-text-wrapper">
                    *ใบเสร็จจะจัดส่งให้ท่านภายใน 5 - 10 วันทำการ หลังจากผ่านการพิจารณารับประกันภัย
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          }
      </>
    )
  }
}